import {
    GO_FLOW_OPENABLE_APEX_ENROLLMENT_TYPES,
    InvestmentManagementAccountType,
    ReadableApexAccountRegistrationType,
    ReadableInvestmentManagementAccountType,
    SupportedApexAccountRegistrationType,
} from '@fruitful/types';

export const getInvestmentManagementAccountTypeLabelValueOptions = () => {
    return Object.values(InvestmentManagementAccountType).map((value) => ({
        label: ReadableInvestmentManagementAccountType[value],
        value,
    }));
};

export const getApexAccountTypeLabelValueOptions = (
    isSoloMembership: boolean,
) => {
    return GO_FLOW_OPENABLE_APEX_ENROLLMENT_TYPES.map((value) => ({
        label: ReadableApexAccountRegistrationType[value],
        value,
        enabled:
            value !==
                SupportedApexAccountRegistrationType.RegistrationJointWros ||
            !isSoloMembership,
    }));
};
